<div class="w-full flex items-center justify-center">
    <img src="../assets/imgs/mobydyThumbnail.png" class="w-50 h-auto md:w-50 lg:w-50 drop-shadow-lg p-2 rounded-lg" alt="Logo">
</div>
<div style="width: 200px; text-align: center;">
    <p class="text-xs text-gray-800">v {{appVersion}}</p>
</div>
